// ─────────────────────────────────────────────────────────────────────────────
// Action-plan API client
//
// When a user picks an action off an insight card, the PAR Intelligence drawer
// shows a draft plan (a "what happens" summary + ordered steps). Those steps used
// to be a static list keyed only by action kind, so "Delete Campaign" and
// "Retarget Segment" read identically. This client asks the backend LLM to
// compose a plan that adapts to the specific insight and chosen action.
// ─────────────────────────────────────────────────────────────────────────────

import apiUtil from "@/util/apiUtil";

const BASE_URL = "/api/ActionPlan";

export interface ActionPlanField {
    label: string;
    value: string;
}

export interface ActionPlanRequest {
    insightTitle?: string;
    insightSummary?: string;
    actionTitle: string;
    actionCategory?: string;
    actionKind?: string;
    campaignAction?: string;
    impactSummary?: string;
    fields?: ActionPlanField[];
}

export interface ActionPlanStep {
    label: string;
    detail?: string;
}

export interface ActionPlanResultField {
    label: string;
    value: string;
    hint?: string;
}

export interface ActionPlan {
    intent: string;
    steps: ActionPlanStep[];
    fields: ActionPlanResultField[];
}

/** Ask the backend LLM to compose an adaptive action plan for this insight action. */
export function generateActionPlan(
    request: ActionPlanRequest,
    signal?: AbortSignal
): Promise<ActionPlan> {
    return apiUtil.postData<ActionPlan>(`${BASE_URL}/generate`, request, signal);
}
